import React                    from 'react';
import {
    useLocation
}                               from "react-router-dom";

const useRouter = () => {
    const location          = useLocation();
    const pathnameSlicer    = 1;
    const route             = location.pathname.split('/')[pathnameSlicer];

    
    return React.useMemo( () => (
        {
            route
        }
    ), [ route ])
}

export default useRouter;